import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgChevronLeft(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.2678 15.9999L22.2678 24.9999L20.5 26.7677L10.6161 16.8838C10.3817 16.6494 10.25 16.3314 10.25 15.9999C10.25 15.6684 10.3817 15.3505 10.6161 15.116L20.5 5.23218L22.2678 6.99995L13.2678 15.9999Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronLeft);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
